import { render, staticRenderFns } from "./VUserIds.vue?vue&type=template&id=403790c2&scoped=true"
import script from "./VUserIds.vue?vue&type=script&lang=ts"
export * from "./VUserIds.vue?vue&type=script&lang=ts"
import style0 from "./VUserIds.vue?vue&type=style&index=0&id=403790c2&prod&lang=scss&scoped=true"
import style1 from "./VUserIds.vue?vue&type=style&index=1&id=403790c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403790c2",
  null
  
)

export default component.exports